import FilterLayout from './src/filter-layout.vue'

FilterLayout.install = function(Vue) {
  Vue.component(FilterLayout.name, FilterLayout)
}

export default FilterLayout
